import { Typography } from '@mui/material';

export const TextError = ({ errorText }: { errorText: string }) => {
  return (
    <Typography color="red" fontSize={'14px'} fontWeight="normal">
      {errorText}
    </Typography>
  );
};
